import { useSelector } from "react-redux";

import { selectPermissions } from "@/app/auth/auth.slice";

export enum Permission {
  /**
   * @description Usuario con permisos multi centro
   */
  MULTI_CENTRO = "multi_centro",

  /**
   * @description Usuario con permiso para editar usuarios y permisos
   */
  EDITAR_USUARIOS = "editar_usuarios",

  /**
   * @description Acceso a la pestaña de KPIs
   */
  ACCESS_KPI = "access_kpi",

  /**
   * @description Resumen
   */
  KPI_SUMMARY = "kpi.summary",

  /**
   * @description Perfil del cliente
   */
  KPI_CLIENT_PROFILE = "kpi.client_profile",

  /**
   * @description Ingresos
   */
  KPI_REVENUE = "kpi.revenue",

  /**
   * @description Gastos
   */
  KPI_EXPENSES = "kpi.expenses",

  /**
   * @description Beneficios
   */
  KPI_PROFITS = "kpi.profits",

  /**
   * @description Adquisición y retención
   */
  KPI_ACQUISITION_AND_RETENTION = "kpi.acquisition_and_retention",

  /**
   * @description Utilización y ocupación
   */
  KPI_UTILIZATION_AND_OCCUPANCY = "kpi.utilization_and_occupancy",

  /**
   * @description Evaluación de servicios
   */
  KPI_SERVICE_EVALUATION = "kpi.service_evaluation",

  /**
   * @description Programas de formación y nutrición
   */
  KPI_TRAINING_AND_NUTRITION_PROGRAMS = "kpi.training_and_nutrition_programs",

  /**
   * @description Acceso a la pestaña de compañías
   */
  COMPANY_ACCESS = "companies.access",

  /**
   * @description Crear y editar compañías
   */
  COMPANY_CREATE_AND_EDIT = "companies.create_edit",

  /**
   * @description Eliminar compañías
   */
  COMPANY_DELETE = "companies.delete",

  /**
   * @description Acceso a la pestaña de usuarios
   */
  USERS_ACCESS = "users.access",

  /**
   * @description Listar usuarios
   */
  USERS_LIST = "users.list",

  /**
   * @description Crear y editar usuarios
   */
  USERS_CREATE_AND_EDIT = "users.create_and_edit",

  /**
   * @description Gestión operativa y financiera
   */
  USERS_OPERATIONAL_AND_FINANCIAL_MANAGEMENT = "users.operational_and_financial_management",

  /**
   * @description Retención de clientes
   */
  USERS_CLIENT_RETENTION = "users.client_retention",

  /**
   * @description Experiencia del cliente
   */
  USERS_CLIENT_EXPERIENCE = "users.client_experience",

  /**
   * @description Crear usuarios
   */
  USERS_CREATE_USERS = "users.create_users",

  /**
   * @description Cambiar filial del usuario
   */
  USERS_CHANGE_USER_BRANCH = "users.change_user_branch",

  /**
   * @description Activar/deshabilitar usuarios
   */
  USERS_ACTIVATE_DISABLE_USERS = "users.activate_disable_users",

  /**
   * @description Asignar etiquetas de usuario
   */
  USERS_ASSIGN_USER_TAGS = "users.assign_user_tags",

  /**
   * @description Asignar etiquetas de marketing
   */
  USERS_ASSIGN_MARKETING_TAGS = "users.assign_marketing_tags",

  /**
   * @description Restablecer contraseña
   */
  USERS_RESET_PASSWORD = "users.reset_password",

  /**
   * @description Firmar contrato
   */
  USERS_SIGN_CONTRACT = "users.sign_contract",

  /**
   * @description Crear tareas
   */
  LOYALTY_CREATE_TASKS = "loyalty.create_tasks",

  /**
   * @description Ver tareas completadas
   */
  LOYALTY_VIEW_COMPLETED_TASKS = "loyalty.view_completed_tasks",

  /**
   * @description Generar incidencias
   */
  LOYALTY_GENERATE_INCIDENTS = "loyalty.generate_incidents",

  /**
   * @description Editar notas
   */
  LOYALTY_EDIT_NOTES = "loyalty.edit_notes",

  /**
   * @description Planes de entrenamiento
   */
  CUSTOMER_EXPERIENCE_TRAINING_PLANS = "customer_experience.training_plans",

  /**
   * @description Planes de nutrición
   */
  CUSTOMER_EXPERIENCE_NUTRITION_PLANS = "customer_experience.nutrition_plans",

  /**
   * @description Valoración antropométrica y funcional del usuario
   */
  CUSTOMER_EXPERIENCE_ANTHROPOMETRIC_AND_FUNCTIONAL_ASSESSMENT = "customer_experience.anthropometric_and_functional_assessment",

  /**
   * @description Valoración del estado de salud y hábitos del usuario
   */
  CUSTOMER_EXPERIENCE_HEALTH_AND_HABITS_ASSESSMENT = "customer_experience.health_and_habits_assessment",

  /**
   * @description Acceso a todas las filiales de la compañía
   */
  BRANCH_ACCESS_ALL_BRANCHES = "branch_access.all_branches",

  /**
   * @description Crear/Editar personal
   */
  BRANCH_ACCESS_CREATE_EDIT_STAFF = "branch_access.create_edit_staff",

  /**
   * @description Cambiar de rama de personal
   */
  BRANCH_ACCESS_CHANGE_STAFF_BRANCH = "branch_access.change_staff_branch",

  /**
   * @description Activar/Desactivar personal
   */
  BRANCH_ACCESS_ACTIVATE_DISABLE_STAFF = "branch_access.activate_disable_staff",

  /**
   * @description Restablecer la contraseña del personal
   */
  BRANCH_ACCESS_RESET_BRANCH_PASSWORD = "branch_access.reset_branch_password",

  /**
   * @description Ver resumen contable y totales, incluyendo exportación a Excel
   */
  BRANCH_ACCESS_VIEW_ACCOUNTING_SUMMARY = "branch_access.view_accounting_summary",

  /**
   * @description Ver detalles de transacciones, incluyendo exportación a Excel y tickets individuales
   */
  BRANCH_ACCESS_VIEW_TRANSACTION_DETAILS = "branch_access.view_transaction_details",

  /**
   * @description Eliminar transacciones en contabilidad
   */
  BRANCH_ACCESS_DELETE_TRANSACTIONS = "branch_access.delete_transactions",

  /**
   * @description Gestionar gastos
   */
  BRANCH_ACCESS_MANAGE_EXPENSES = "branch_access.manage_expenses",

  /**
   * @description Gestionar acuerdos de la compañía
   */
  BRANCH_ACCESS_MANAGE_COMPANY_AGREEMENTS = "branch_access.manage_company_agreements",

  /**
   * @description Gestión XML para domiciliación bancaria
   */
  BRANCH_ACCESS_XML_MANAGEMENT = "branch_access.xml_management",

  /**
   * @description Crear ingresos manuales
   */
  BRANCH_ACCESS_CREATE_MANUAL_INCOME = "branch_access.create_manual_income",

  /**
   * @description Acceso a la pestaña de tienda
   */
  ACCESS_STORE_TAB = "access_store_tab",

  /**
   * @description Poder vender productos en la pestaña de tienda
   */
  SELL_PRODUCTS_STORE_TAB = "sell_store_products",

  /**
   * @description Ver KPI venta de productos por personal
   */
  VIEW_KPI_SALES_BY_STAFF = "view_kpi_sales_by_staff",

  /**
   * @description Acceso a la pestaña de mantenimiento
   */
  BRANCH_ACCESS_VIEW_MAINTENANCE = "branch_access.view_maintenance",

  /**
   * @description Crear mantenimiento
   */
  BRANCH_ACCESS_CREATE_MAINTENANCE = "branch_access.create_maintenance",

  /**
   * @description Editar mantenimiento
   */
  BRANCH_ACCESS_EDIT_MAINTENANCE = "branch_access.edit_maintenance",

  /**
   * @description Completar mantenimiento
   */
  BRANCH_ACCESS_COMPLETE_MAINTENANCE = "branch_access.complete_maintenance",

  /**
   * @description Ver inventario
   */
  BRANCH_ACCESS_VIEW_INVENTORY = "branch_access.view_inventory",

  /**
   * @description Crear inventario
   */
  BRANCH_ACCESS_CREATE_INVENTORY = "branch_access.create_inventory",

  /**
   * @description Editar inventario
   */
  BRANCH_ACCESS_EDIT_INVENTORY = "branch_access.edit_inventory",

  /**
   * @description Eliminar inventario
   */
  BRANCH_ACCESS_DELETE_INVENTORY = "branch_access.delete_inventory",

  /**
   * @description Crear actividad
   */
  BRANCH_ACCESS_CREATE_ACTIVITY = "branch_access.create_activity",

  /**
   * @description Editar actividades
   */
  BRANCH_ACCESS_EDIT_ACTIVITIES = "branch_access.edit_activities",

  /**
   * @description Eliminar actividades
   */
  BRANCH_ACCESS_DELETE_ACTIVITIES = "branch_access.delete_activities",

  /**
   * @description Ver/editar lista de espera en actividades dirigidas
   */
  BRANCH_ACCESS_VIEW_EDIT_WAITLIST_IN_ACTIVITIES = "branch_access.view_edit_waitlist_in_activities",

  /**
   * @description Editar tiempos en actividades dirigidas
   */
  BRANCH_ACCESS_EDIT_TIMES_IN_ACTIVITIES = "branch_access.edit_times_in_activities",

  /**
   * @description Subir calendario
   */
  BRANCH_ACCESS_UPLOAD_CALENDAR = "branch_access.upload_calendar",

  /**
   * @description Editar festivos en actividades dirigidas
   */
  BRANCH_ACCESS_EDIT_HOLIDAYS_IN_ACTIVITIES = "branch_access.edit_holidays_in_activities",

  /**
   * @description Crear/editar salas en actividades dirigidas
   */
  BRANCH_ACCESS_CREATE_EDIT_ROOMS_IN_ACTIVITIES = "branch_access.create_edit_rooms_in_activities",

  /**
   * @description Crear servicios profesionales
   */
  BRANCH_ACCESS_CREATE_PROFESSIONAL_SERVICES = "branch_access.create_professional_services",

  /**
   * @description Editar servicios profesionales
   */
  BRANCH_ACCESS_EDIT_PROFESSIONAL_SERVICES = "branch_access.edit_professional_services",

  /**
   * @description Eliminar servicios profesionales
   */
  BRANCH_ACCESS_DELETE_PROFESSIONAL_SERVICES = "branch_access.delete_professional_services",

  /**
   * @description Ver/editar lista de espera en servicios profesionales
   */
  BRANCH_ACCESS_VIEW_EDIT_WAITLIST_IN_PROFESSIONAL_SERVICES = "branch_access.view_edit_waitlist_in_professional_services",

  /**
   * @description Editar tiempos en servicios profesionales
   */
  BRANCH_ACCESS_EDIT_TIMES_IN_PROFESSIONAL_SERVICES = "branch_access.edit_times_in_professional_services",

  /**
   * @description Editar festivos en servicios profesionales
   */
  BRANCH_ACCESS_EDIT_HOLIDAYS_IN_PROFESSIONAL_SERVICES = "branch_access.edit_holidays_in_professional_services",

  /**
   * @description Crear/editar salas en servicios profesionales
   */
  BRANCH_ACCESS_CREATE_EDIT_ROOMS_IN_PROFESSIONAL_SERVICES = "branch_access.create_edit_rooms_in_professional_services",

  /**
   * @description Crear/editar bonos de servicios profesionales
   */
  BRANCH_ACCESS_CREATE_EDIT_PROFESSIONAL_SERVICE_BONUSES = "branch_access.create_edit_professional_service_bonuses",

  /**
   * @description Pausar/despausar bonos de servicios profesionales
   */
  BRANCH_ACCESS_PAUSE_DEPAUSE_PROFESSIONAL_SERVICE_BONUSES = "branch_access.pause_despause_professional_service_bonuses",

  /**
   * @description Ver KPI venta de servicios profesionales por personal
   */
  BRANCH_ACCESS_VIEW_KPI_PROFESSIONAL_SERVICE_SALES_BY_STAFF = "branch_access.view_kpi_professional_service_sales_by_staff",

  /**
   * @description Crear espacios
   */
  BRANCH_ACCESS_CREATE_SPACES = "branch_access.create_spaces",

  /**
   * @description Editar espacios
   */
  BRANCH_ACCESS_EDIT_SPACES = "branch_access.edit_spaces",

  /**
   * @description Eliminar espacios
   */
  BRANCH_ACCESS_DELETE_SPACES = "branch_access.delete_spaces",

  /**
   * @description Editar tiempos en gestión de espacios
   */
  BRANCH_ACCESS_EDIT_TIMES_IN_SPACES = "branch_access.edit_times_in_spaces",

  /**
   * @description Editar festivos en gestión de espacios
   */
  BRANCH_ACCESS_EDIT_HOLIDAYS_IN_SPACES = "branch_access.edit_holidays_in_spaces",

  /**
   * @description Crear/editar espacios físicos
   */
  BRANCH_ACCESS_CREATE_EDIT_DELETE_PHYSICAL_SPACES = "branch_access.create_edit_delete_physical_spaces",

  /**
   * @description Crear/editar bonos de espacios
   */
  BRANCH_ACCESS_CREATE_EDIT_SPACE_BONUSES = "branch_access.create_edit_space_bonuses",

  /**
   * @description Eliminar bonos de espacios
   */
  BRANCH_ACCESS_DELETE_SPACE_BONUSES = "branch_access.delete_space_bonuses",

  /**
   * @description Ver KPI venta de espacios por personal
   */
  BRANCH_ACCESS_VIEW_KPI_SPACE_SALES_BY_STAFF = "branch_access.view_kpi_space_sales_by_staff",

  /**
   * @description Habilitar cursos
   */
  BRANCH_ACCESS_VIEW_COURSES = "branch_access.view_courses",

  /**
   * @description Crear cursos
   */
  BRANCH_ACCESS_CREATE_COURSES = "branch_access.create_courses",

  /**
   * @description Editar cursos
   */
  BRANCH_ACCESS_EDIT_COURSES = "branch_access.edit_courses",

  /**
   * @description Eliminar cursos
   */
  BRANCH_ACCESS_DELETE_COURSES = "branch_access.delete_courses",

  /**
   * @description Habilitar vista usuarios
   */
  BRANCH_ACCESS_VIEW_USERS_COURSES = "branch_access.view_users_courses",

  /**
   * @description Habilitar clases pre-grabadas
   */
  BRANCH_ACCESS_VIEW_PRE_RECORDED_CLASSES = "branch_access.view_pre_recorded_classes",

  /**
   * @description Crear clases pre-grabadas
   */
  BRANCH_ACCESS_CREATE_PRE_RECORDED_CLASSES = "branch_access.create_pre_recorded_classes",

  /**
   * @description Editar clases pre-grabadas
   */
  BRANCH_ACCESS_EDIT_PRE_RECORDED_CLASSES = "branch_access.edit_pre_recorded_classes",

  /**
   * @description Eliminar clases pre-grabadas
   */
  BRANCH_ACCESS_DELETE_PRE_RECORDED_CLASSES = "branch_access.delete_pre_recorded_classes",

  /**
   * @description Crear/editar/activar postas chat interno
   */
  BRANCH_ACCESS_CREATE_EDIT_ACTIVATE_INTERNAL_CHAT_POSTS = "branch_access.create_edit_activate_internal_chat_posts",

  /**
   * @description Acceso a la pestaña de cuotas
   */
  BRANCH_ACCESS_VIEW_FEES = "branch_access.view_fees",

  /**
   * @description Crear cuotas
   */
  BRANCH_ACCESS_CREATE_FEE = "branch_access.create_fee",

  /**
   * @description Editar cuotas
   */
  BRANCH_ACCESS_EDIT_FEE = "branch_access.edit_fee",

  /**
   * @description Pausar cuotas
   */
  BRANCH_ACCESS_STOP_FEE = "branch_access.stop_fee",

  /**
   * @description Crear/editar etiquetas de usuario y marketing
   */
  BRANCH_ACCESS_CREATE_EDIT_USER_AND_MARKETING_TAGS = "branch_access.create_edit_user_and_marketing_tags",

  /**
   * @description Acceso al Tab Renovaciones Retrasadas
   */

  BRANCH_ACCESS_RECOVERY_LATEST = "branch_access.recovery_latest",

  /**
   * @description Acceso al Tab Acceso al Tab Bajas Antigüas
   */

  BRANCH_ACCESS_RECOVERY_OLD = "branch_access.recovery_latest",

  /**
   * @description Contratos y clausulas con clientes
   */
  BRANCH_ACCESS_CONTRACTS_CLAUSES_CUSTOMERS = "branch_access.contracts_clauses_customers",

  /**
   * @description Impuestos y recibos con clientes
   */
  BRANCH_ACCESS_TAXES_RECEIPTS_CUSTOMERS = "branch_access.taxes_receipts_customers",

  /**
   * @description Personalizar del logo y los colores corporativos
   */
  BRANCH_ACCESS_CUSTOMIZE_LOGO_AND_COLORS = "branch_access.customize_logo_and_colors",

  /**
   * @description Personalizar los videos de ejercicios
   */
  BRANCH_ACCESS_CUSTOMIZE_EXERCISE_VIDEOS = "branch_access.customize_exercise_videos",

  /**
   * @description Vinculación de dispositivos
   */
  BRANCH_ACCESS_DEVICE_LINKING = "branch_access.device_linking",

  /**
   * @description Integración contabilidad
   */
  BRANCH_ACCESS_ACCOUNTING_INTEGRATION = "branch_access.accounting_integration",

  /**
   * @description Mi suscripción Fitmewise
   */
  BRANCH_ACCESS_FITMEWISE_SUBSCRIPTION = "branch_access.fitmewise_subscription",

  /**
   * @description Gestión de cuotas en usuarios
   */
  USER_FEE_MANAGEMENT = "user_fee_management",

  /**
   * @description Asignar cuotas
   */
  ASSIGN_FEES = "assign_fees",

  /**
   * @description Dar de baja
   */
  DEACTIVATE_USER = "deactivate_user",

  /**
   * @description Pausar cuota por días exactos
   */
  PAUSE_FEE_EXACT_DAYS = "pause_fee_exact_days",

  /**
   * @description Pausar cuota desde/hasta un periodo determinado
   */
  PAUSE_FEE_PERIOD = "pause_fee_period",

  /**
   * @description Gestión de actividades dirigidas en usuarios
   */
  USER_ACTIVITY_MANAGEMENT = "user_activity_management",

  /**
   * @description Permitir reservas de actividades sin importar la cuota o bono activo
   */
  ALLOW_ACTIVITY_RESERVATIONS = "allow_activity_reservations",

  /**
   * @description Gestión de servicios profesionales en usuarios
   */
  USER_PROFESSIONAL_SERVICE_MANAGEMENT = "user_professional_service_management",

  /**
   * @description Editar número de sesiones en un bono (aumentar/disminuir) en servicios profesionales
   */
  EDIT_SERVICE_SESSIONS = "edit_service_sessions",

  /**
   * @description Apuntar al usuario en un servicio profesional
   */
  ENROLL_USER_PROFESSIONAL_SERVICE = "enroll_user_professional_service",

  /**
   * @description Asignar bonos en servicios profesionales
   */
  ASSIGN_SERVICE_BONUSES = "assign_service_bonuses",

  /**
   * @description Gestión de espacios en usuarios
   */
  USER_SPACE_MANAGEMENT = "user_space_management",

  /**
   * @description Asignar bonos para espacios
   */
  ASSIGN_SPACE_BONUSES = "assign_space_bonuses",

  /**
   * @description Editar número de sesiones en un bono (aumentar/disminuir) en gestión de espacios
   */
  EDIT_SPACE_SESSIONS = "edit_space_sessions",

  /**
   * @description Apuntar al usuario en un servicio profesional de gestión de espacios
   */
  ENROLL_USER_SPACE_SERVICE = "enroll_user_space_service",

  /**
   * @description Gestión de tienda en usuarios
   */
  USER_STORE_MANAGEMENT = "user_store_management",

  /**
   * @description Poder vender productos en tienda de usuarios
   */
  SELL_STORE_PRODUCTS = "sell_store_products",

  /**
   * @description Catchment campaigns
   */
  CATCHMENT_CAMPAIGNS = "catchment.campaigns",

  /**
   * @description Catchment direct
   */
  CATCHMENT_DIRECT = "catchment.direct",

  /**
   * @description Crear/editar roles y permisos
   */
  BRANCH_ACCESS_CREATE_EDIT_ROLES_AND_PERMISSIONS = "branch_access.create_edit_roles_and_permissions",
}

export function usePermission() {
  const permissions = useSelector(selectPermissions);

  return {
    can: (permission: Permission, value?: any) => {
      const can = !!permissions?.find(
        (_permission: string) => _permission == permission
      );

      return value ? (can ? value : undefined) : can;
    },
    cant: (permission: Permission) => {
      return !permissions?.find(
        (_permission: string) => _permission == permission
      );
    },
  };
}
